/** @format */

import styled from '@emotion/styled';

export const StyledTbody = styled.tbody``;
